<template>
    <path 
      :d="`M ${(cx-r)}, ${cy} 
      a ${r}, ${r} 0 1, 1 ${r*2}, 0 
      a ${r}, ${r} 0 1, 1 -${r*2}, 0`"
      :fill="`url(#${fill})`"
      :id="`dot-${id}-${fill}`">
    <animateTransform
      attributeName="transform"
      type="translate"
      attributeType="XML"
      repeatCount="indefinite"
      :values="wiggleArr.join(';')"
      keyTimes="0;.1;.22;.33;.44;.55;.66;.77;.88;1"
      dur="400ms"
      begin="0s;"
      fill="freeze"
      />
    </path>
</template>


<script>
export default {
  name:"Dot",
  props:{
    cx: Number,
    cy: Number,
    r: Number,
    wiggle: Number,
    fill: String,
    id: Number
  },
  data() {
    return {
      x: Number,
      y: Number,
      wiggleArr: [],
      key: 1
    }
  },
  methods: {
    
    setWiggle(){
      this.wiggleArr=['0, 0']
      let self = this;
      let randoX, randoY, x, y;
      let w = this.wiggle;

      for(let i=0; i < 8; i++){
        if(w !== 0){
          randoX = Math.floor(Math.random() * w) - w * 2;
          randoY = Math.floor(Math.random() * w) - w * 2;
          x = randoX * (Math.random() < 0.5 ? -1 : 1)
          y = randoY * (Math.random() < 0.5 ? -1 : 1)
          self.wiggleArr.push(`${x}, ${y}`)
        }else{
          self.wiggleArr.push('0,0')
        }
      }

      self.wiggleArr.push('0, 0')
    }
  },
  created() {
    this.x = this.cx
    this.y = this.cy
    this.originalX = this.cx
    this.originalY = this.cy
  },
  mounted() {
    this.setWiggle()
  },
  watch: {
    wiggle: function () {
      this.setWiggle()
    }
  },
}

</script>
